<div class="col-lg-12 content-scroll-screen parent">
  <p-card class="card-spacing-0">
    <div class="p-3">
      <div
        class="d-flex justify-content-between align-items-center pb-2 mb-2 globalborder-btm-header">
        <h1 class="m-0">Proposal</h1>
        <h1 *ngIf="avaiableCredit" class="available-credit">
          Available Credit: {{ avaiableCredit | currency }}
        </h1>
        <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="row adduser-container-hgt">
        <form [formGroup]="QuoteForm">
          <div class="gray-bg-rounded mb-3">
            <jni-header-quote
              [parent]="QuoteForm"
              [bacUserDefaultSelectionId]="bacUserDefaultSelectionId"
              [bacList]="bacList"
              [brandingConsultantLists]="brandingConsultantLists"
              [deliveryAddress]="deliveryAddress"
              (bcSelectionEvent)="getBacForSalesOrder($event)"
              (customerBillToObjectEvent)="getCustomerBillToData($event)"
              [formErrors]="formErrors"
              [customerPaymentMethodList]="customerPaymentMethodList"
              (validationErrorEvent)="logValidationErrors()"
              (smallLoaderEvent)="getLoaderStatus($event)"
              (clearShipToEvent)="clearShipAddressForm()"
              (bcSelectionForProspect)="bcSelectionForProspect($event)"
              [customerBillToObject]="customerBillToObject"
              (buyerChangeEvent)="buyerChangeEvent()"
              (selectedClientCurrencyEvent)="
                patchValueInCurrencyFieldEvent($event)
              "></jni-header-quote>
          </div>
          <div class="row">
            <div class="col-3">
              <div class="gray-bg-rounded">
                <jni-header-customer-address [parent]="QuoteForm">
                </jni-header-customer-address>
              </div>
            </div>
            <div class="col-3">
              <div class="gray-bg-rounded">
                <jni-ship-to-address
                  #shipTo
                  [parent]="QuoteForm"
                  [deliveryAddress]="deliveryAddress"
                  [countryRegionList]="countryRegionList"
                  [customerBillToObject]="customerBillToObject"
                  (smallLoaderEvent)="getLoaderStatus($event)"
                  [isShipToAddressFromProposal]="true"
                  [showAddress]="false"
                  [formgroupName]="'shipTo'"
                  [formErrors]="formErrors"
                  (validationErrorEvent)="logValidationErrors()">
                </jni-ship-to-address>
              </div>
            </div>
            <div class="col-6">
              <div class="gray-bg-rounded">
                <jni-header-invoice-emails
                  [invoiceListing]="invoiceListing"
                  [parent]="QuoteForm"
                  (newLine)="addNewLine($event)"
                  (removeEmail)="removeEmail($event)"
                  *ngIf="QuoteForm.value"></jni-header-invoice-emails>
                <div class="mb-2">
                  <jni-header-details
                    #proposalHeaderDetails
                    [parent]="QuoteForm"
                    [shippingProductsList]="shippingProductsList"
                    [currencyList]="currencyList"
                    [formErrors]="formErrors"
                    (validationErrorEvent)="logValidationErrors()"
                    [customerPaymentMethodList]="customerPaymentMethodList"
                    [applyCreditCardList]="applyCreditCardList"
                    [contactLists]="ClientAddresses"
                    [isCustomerPoRequiredField]="isCustomerPoRequiredField"
                    (contactListRefreshGrid)="contactListRefreshGrid($event)"
                    [customerBillToObject]="customerBillToObject"
                    (buyerChangeEvent)="
                      buyerChangeEvent()
                    "></jni-header-details>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex py-3 gap-3 has-sticky justify-content-end">
            <p-button
              label="Cancel"
              (click)="goToQuotesListing()"
              variant="outlined"
              severity="secondary" />

            <p-button label="Save" type="submit" (click)="onSubmit()" />
          </div>
        </form>
      </div>
    </div>
  </p-card>
</div>
